// import Navbar from "./Navbar";
import React, { useState, useEffect } from "react";
import { MdPageview } from "react-icons/md";
// import Button from "react-bootstrap/Button";
// import Modal from "react-bootstrap/Modal";
import axios from "axios";
// import "./Listings.css";
// import ReactPaginate from "react-paginate";

import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { FaImages } from "react-icons/fa";
import "./Directory.css";
import ReactPaginate from "react-paginate";
import { AiFillDelete } from "react-icons/ai";

function Add_SubCategory() {
  const [dataSource, setdataSource] = useState([]);
  const [dataSource1, setdataSource1] = useState([]);

  const formdata = new FormData();

  useEffect(() => {
    AllPartners();
    AllSubCategory();
  }, []);

  const AllPartners = async () => {
    let res = await axios.get("https://maargdarshak.in/api/user/getCategory");
    if (res.status === 200) {
      // console.log(res);
      setdataSource(res.data.CategoryInfo);
    }
  };

  const AllSubCategory = async () => {
    let res = await axios.get(
      "https://maargdarshak.in/api/user/getSubCategory"
    );
    if (res.status === 200) {
      // console.log(res);
      setdataSource1(res.data.SubCategoryInfo);
    }
  };

  const [dataSource2, setdataSource2] = useState([]);

  useEffect(() => {
    AllPartners1();
  }, []);

  const AllPartners1 = async () => {
    let res = await axios.get("https://maargdarshak.in/api/user/getCategory1");
    if (res.status === 200) {
      // console.log(res);
      setdataSource2(res.data.Category1Info);
    }
  };

  const [category, setcategory] = useState();
  const [SubCategoryImage, setSubCategoryImage] = useState();
  const [Title, setTitle] = useState();
  const [SubTitle, setSubTitle] = useState();
  const [Description, setDescription] = useState();
  const [SubCategoryLink, setSubCategoryLink] = useState();
  const [Page, setPage] = useState();
  const [Subcategory, setSubcategory] = useState();

  const [show, setshow] = useState(false);

  const handleClose = () => {
    setshow(false);
  };

  const AddCategory = async (e) => {
    e.preventDefault();
    if (!category) {
      alert("Please Enter Category Name");
      return;
    }
    if (!Subcategory) {
      alert("Please Select Sub-Category");
      return;
    }
    if (!SubCategoryImage) {
      alert("Please Select Image");
      return;
    }
    formdata.append("CategoryName", category.toUpperCase());
    formdata.append("SubCategoryImage", SubCategoryImage);
    // formdata.append("Title", Title);
    formdata.append("SubTitle", SubTitle);
    formdata.append("Description", Description);
    formdata.append("SubCategoryLink", SubCategoryLink);
    formdata.append("Page", Page);
    formdata.append("SubCategoryName", Subcategory);

    try {
      const config = {
        url: "/user/addSubCategory",
        method: "post",
        baseURL: "https://maargdarshak.in/api",
        hearder: { "content-type": "application/json" },

        data: formdata,
      };
      await axios(config).then(function (res) {
        if (res.status === 200) {
          // console.log(res.data);
          alert("Link Added");
          setshow(false);
          setcategory();
          setcategory();
          setSubCategoryImage();
          setSubcategory();
          setTitle();
          setSubTitle();
          setDescription();
          setSubCategoryLink();
          setPage();
          AllSubCategory();
        } else {
          alert("Something Wrong");
        }
      });
    } catch (error) {
      console.log(error.response);
    }
  };

  const [pageNumber, setPageNumber] = useState(0);

  const usersPerPage = 5;
  const pagesVisited = pageNumber * usersPerPage;
  const pageCount = Math.ceil(dataSource1.length / usersPerPage);
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  const DeleteCategory = async (item) => {
    try {
      const config = {
        url: "/user/RemoveSubCategory",
        method: "post",
        baseURL: "https://maargdarshak.in/api",
        hearder: { "content-type": "application/json" },

        data: { SubCategoryId: item._id },
      };
      await axios(config).then(function (res) {
        if (res.status === 200) {
          // console.log(res.data);
          alert("Link Deleted");
          AllSubCategory();
        } else {
          alert("Something Wrong");
        }
      });
    } catch (error) {
      console.log(error.response);
    }
  };

  return (
    <div style={{ backgroundColor: "#f3f3f9", paddingBottom: "100px" }}>
      {/* <Navbar /> */}
      <div style={{ padding: "1% 2%" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "10px 20px 0px 20px",
          }}
        >
          <h6
            style={{
              fontSize: "16px",
              fontWeight: "bold",
            }}
          >
            LINKS
          </h6>
          <button
            style={{
              backgroundColor: "#ff7d26",
              color: "white",
              fontWeight: "600",
              fontSize: "14px",
              padding: "10px 10px",
              borderRadius: "20px",
            }}
            onClick={() => setshow(true)}
          >
            +ADD LINKS
          </button>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="EloetableOrder">
              <div class="card-body">
                <div class="table-responsive">
                  <div class="react-bootstrap-table">
                    <table
                      class="table table align-middle table-nowrap"
                      style={{ width: "96%", margin: "2%" }}
                    >
                      <thead
                        style={{ backgroundColor: "#ff7d26", color: "white" }}
                      >
                        <tr style={{ padding: "10px", textAlign: "center" }}>
                          <th
                            tabindex="0"
                            aria-label="Phone / Email sortable"
                            class="sortable"
                          >
                            CATEGORY NAME{" "}
                            <span class="order">
                              <span class="dropdown">
                                <span class="caret"></span>
                              </span>
                              <span class="dropup">
                                <span class="caret"></span>
                              </span>
                            </span>
                          </th>

                          <th> IMAGE</th>
                          <th> SUB-CATEGORY</th>
                          <th> SUB-TITLE</th>
                          <th> DESCRIPTION</th>
                          <th> LINK</th>
                          <th>REMOVE</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dataSource1
                          .slice(pagesVisited, pagesVisited + usersPerPage)
                          .map((item) => {
                            return (
                              <tr
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                <td>{item.CategoryName}</td>
                                <td>
                                  <img
                                    src={`https://maargdarshak.in/SubCategoryImage/${item.SubCategoryImage}`}
                                    style={{ width: "180px", height: "120px" }}
                                  ></img>
                                </td>
                                <td>{item.SubCategoryName}</td>
                                <td>{item.SubTitle}</td>
                                <td>{item.Description}</td>
                                <td>{item.SubCategoryLink}</td>
                                <td>
                                  <AiFillDelete
                                    onClick={() => DeleteCategory(item)}
                                    style={{ color: "red", fontSize: "25px" }}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </div>
                <Modal
                  show={show}
                  onHide={handleClose}
                  animation={true}
                  style={{
                    marginTop: "1%",
                    overflowY: "scroll",
                    maxHeight: "100%",
                  }}
                >
                  <Modal.Header></Modal.Header>
                  <div class="col-md-12" style={{ margin: "2% 4%" }}>
                    <select
                      style={{
                        width: "90%",
                        padding: "10px 10px",
                        border: "1px solid #ff7d26",
                        marginBottom: "2%",
                      }}
                      onChange={(e) => {
                        setcategory(e.target.value);
                      }}
                    >
                      <option>Select Category</option>
                      {dataSource.map((item) => {
                        return (
                          <option value={item.CategoryName}>
                            {item.CategoryName}
                          </option>
                        );
                      })}
                    </select>
                    <select
                      style={{
                        width: "90%",
                        padding: "10px 10px",
                        border: "1px solid #ff7d26",
                        marginBottom: "2%",
                      }}
                      onChange={(e) => {
                        setPage(e.target.value);
                      }}
                    >
                      <option>Select Page </option>
                      <option value="page1">Page-1</option>
                      <option value="page2">Page-2</option>
                    </select>

                    {/* <input
                      type="text"
                      placeholder="Enter Sub-Category here..."
                      style={{
                        padding: "10px",
                        width: "90%",
                        border: "1px solid #ff7d26",
                        marginBottom: "2%",
                      }}
                      value={Subcategory}
                      onChange={(e) => {
                        setSubcategory(e.target.value);
                      }}
                    /> */}

                    <select
                      style={{
                        width: "90%",
                        padding: "10px 10px",
                        border: "1px solid #ff7d26",
                        marginBottom: "2%",
                      }}
                      onChange={(e) => {
                        setSubcategory(e.target.value);
                      }}
                    >
                      <option>Select Subcategory</option>
                      {dataSource2
                        .filter((data) => data.CategoryName === category)
                        .map((item) => {
                          return (
                            <option value={item.SubcategoryName}>
                              {item.SubcategoryName}
                            </option>
                          );
                        })}
                    </select>

                    {/* <input
                      type="text"
                      placeholder="Title here..."
                      style={{
                        padding: "10px",
                        width: "90%",
                        border: "1px solid #ff7d26",
                        marginBottom: "2%",
                      }}
                      value={Title}
                      onChange={(e) => {
                        setTitle(e.target.value);
                      }}
                    /> */}

                    <input
                      type="text"
                      placeholder="SubTitle here..."
                      style={{
                        padding: "10px",
                        width: "90%",
                        marginBottom: "2%",
                        border: "1px solid #ff7d26",
                      }}
                      value={SubTitle}
                      onChange={(e) => {
                        setSubTitle(e.target.value);
                      }}
                    />

                    <input
                      type="text"
                      placeholder="Description here..."
                      style={{
                        padding: "10px",
                        width: "90%",
                        marginBottom: "2%",
                        border: "1px solid #ff7d26",
                      }}
                      value={Description}
                      onChange={(e) => {
                        setDescription(e.target.value);
                      }}
                    />

                    <input
                      type="text"
                      placeholder="SubCategoryLink here..."
                      style={{
                        padding: "10px",
                        width: "90%",
                        marginBottom: "2%",
                        border: "1px solid #ff7d26",
                      }}
                      value={SubCategoryLink}
                      onChange={(e) => {
                        setSubCategoryLink(e.target.value);
                      }}
                    />

                    {/* <button
              style={{
                padding: "10px",
                color: "white",
                backgroundColor: "#ff7d26",
                border: "none",
              }}
              onClick={addcategory}
            >
              Add Category
            </button> */}
                  </div>
                  <div class="add-list-media-wrap">
                    <div class="listsearch-input-item fl-wrap">
                      <div class="fuzone">
                        <form>
                          <div class="fu-text">
                            <span>
                              {!SubCategoryImage ? (
                                <FaImages
                                  style={{ fontSize: "70px", color: "#ffcc33" }}
                                />
                              ) : (
                                <img
                                  src={URL.createObjectURL(SubCategoryImage)}
                                  alt="Thumb"
                                  style={{
                                    width: "25%",
                                    height: "76px",
                                    paddingTop: "1%",
                                    paddingBottom: "1%",
                                  }}
                                ></img>
                              )}
                              Click here or drop files to upload
                            </span>
                            <div class="photoUpload-files fl-wrap"></div>
                          </div>
                          <input
                            type="file"
                            name="file"
                            id="upload1"
                            accept="image/*"
                            onChange={(e) =>
                              setSubCategoryImage(e.target.files[0])
                            }
                          />
                        </form>
                      </div>
                    </div>
                  </div>
                  <Modal.Footer
                    style={{
                      justifyContent: "space-between",
                      padding: "10px 20px",
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#ffcc33",
                        border: "none",
                        width: "120px",
                      }}
                      onClick={handleClose}
                    >
                      CANCEL
                    </Button>

                    <Button
                      style={{
                        backgroundColor: "#ff7d26",
                        border: "none",
                        width: "180px",
                      }}
                      onClick={AddCategory}
                    >
                      ADD LINK
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ReactPaginate
        previousLabel={"<"}
        nextLabel={">"}
        pageCount={pageCount}
        onPageChange={changePage}
        containerClassName={"paginationBttns"}
        previousLinkClassName={"previousBttn"}
        nextLinkClassName={"nextBttn"}
        disabledClassName={"paginationDisabled"}
        activeClassName={"paginationActive"}
      />
    </div>
  );
}

export default Add_SubCategory;
